import { observer } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../../comps/OcDataview';
import { PleaseWait } from '../../../comps/PleaseWait';
import { DataviewStore } from '../../../stores/DataviewStore';
import { useOmnistore } from '../../../stores/Omnistore';
import { EditBrandDialog } from '../harmo/EditBrandDialog';

const dataviewStore = DataviewStore.create({
	id: 'BrandList',
	orgColumns: [
		'name 200',
		'nameSearchJson :nameSearch 500',
		'id :int 50',
	],
	filtering: [{columns: ['name'], value: ''}],
	sorting: {column: 'name'},
});
dataviewStore.addColumnHiderToNamed('DEFAULT', 'id');

export const BrandPage = observer(function() {
	const brandStore = useOmnistore().multirepo.brandRepo;
	React.useEffect(() => void brandStore.fetch(), []);
	if (!brandStore.etag) return <PleaseWait/>;
	const brand = brandStore.byId(dataviewStore.selectedEntityId);
	return <React.Fragment>
		<OcDataview repo={brandStore} state={dataviewStore}/>
		{!brand ? null : <EditBrandDialog brand={brand} onClose={() => dataviewStore.rowClick(0)}/>}
	</React.Fragment>;
});
